import React, { useCallback, useRef, useState, useEffect } from "react";
import {
  AppProvider,
  ActionList,
  Card,
  TextField,
  Text,
  ContextualSaveBar,
  FormLayout,
  Modal,
  Frame,
  Layout,
  Loading,
  Navigation,
  Page,
  SkeletonBodyText,
  SkeletonDisplayText,
  SkeletonPage,
  Toast,
  TopBar,
  List,
} from "@shopify/polaris";
import {
  ExitIcon,
  PersonFilledIcon,
  DiscountsMajor,
  ListBulletedFilledIcon,
  SettingsFilledIcon,
  InventoryFilledIcon,
  ListBulletedIcon,
  CategoriesIcon,
  BookIcon,
  ClipboardCheckFilledIcon,
  OrderFilledIcon,
  NotificationFilledIcon,
  ImageIcon,
  EmailIcon,
  ChartLineIcon,
  ChartFunnelIcon,
  ChartVerticalFilledIcon,
} from "@shopify/polaris-icons";
import Cookies from "js-cookie";
import logoImg from "../Assets/Images/logoWhite.svg";
import { useNavigate } from "react-router-dom";
import axios from "../Assets/Lib/axios";
import { ListGroup } from "react-bootstrap";

function NavigationLayout(props) {
  // const iconContent = () => {
  //   return (
  //     <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
  //       <circle cx="10" cy="10" r="10" fill="rebeccapurple" />
  //       <circle cx="10" cy="10" r="6" fill="currentColor" />
  //       <circle cx="10" cy="10" r="3" />
  //     </svg>
  //   );
  // };
  const [pendingRequestsNumber, setPendingRequestsNumber] = useState("");
  useEffect(() => {
    axios
      .get(`/requests/pending-count`)
      .then((result) => {
        console.log("pending=", result.data.data);
        setPendingRequestsNumber(result.data.data);
      })
      .catch((err) => console.log(err));
  }, []);
  const navigate = useNavigate();
  const defaultState = useRef({
    emailFieldValue: "dharma@jadedpixel.com",
    nameFieldValue: "Jaded Pixel",
  });
  const skipToContentRef = useRef(null);

  const [toastActive, setToastActive] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const [searchActive, setSearchActive] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [userMenuActive, setUserMenuActive] = useState(false);
  const [mobileNavigationActive, setMobileNavigationActive] = useState(false);
  const [modalActive, setModalActive] = useState(false);
  const [nameFieldValue, setNameFieldValue] = useState(
    defaultState.current.nameFieldValue
  );
  const [emailFieldValue, setEmailFieldValue] = useState(
    defaultState.current.emailFieldValue
  );
  const [storeName, setStoreName] = useState(
    defaultState.current.nameFieldValue
  );
  const [supportSubject, setSupportSubject] = useState("");
  const [supportMessage, setSupportMessage] = useState("");

  const handleSubjectChange = useCallback(
    (value) => setSupportSubject(value),
    []
  );
  const handleMessageChange = useCallback(
    (value) => setSupportMessage(value),
    []
  );
  const handleDiscard = useCallback(() => {
    setEmailFieldValue(defaultState.current.emailFieldValue);
    setNameFieldValue(defaultState.current.nameFieldValue);
    setIsDirty(false);
  }, []);
  const handleSave = useCallback(() => {
    defaultState.current.nameFieldValue = nameFieldValue;
    defaultState.current.emailFieldValue = emailFieldValue;

    setIsDirty(false);
    setToastActive(true);
    setStoreName(defaultState.current.nameFieldValue);
  }, [emailFieldValue, nameFieldValue]);
  const handleNameFieldChange = useCallback((value) => {
    setNameFieldValue(value);
    value && setIsDirty(true);
  }, []);
  const handleEmailFieldChange = useCallback((value) => {
    setEmailFieldValue(value);
    value && setIsDirty(true);
  }, []);
  const handleSearchResultsDismiss = useCallback(() => {
    setSearchActive(false);
    setSearchValue("");
  }, []);
  const handleSearchFieldChange = useCallback((value) => {
    setSearchValue(value);
    setSearchActive(value.length > 0);
  }, []);
  const toggleToastActive = useCallback(
    () => setToastActive((toastActive) => !toastActive),
    []
  );
  const toggleUserMenuActive = useCallback(
    () => setUserMenuActive((userMenuActive) => !userMenuActive),
    []
  );
  const toggleMobileNavigationActive = useCallback(
    () =>
      setMobileNavigationActive(
        (mobileNavigationActive) => !mobileNavigationActive
      ),
    []
  );
  const toggleIsLoading = useCallback(
    () => setIsLoading((isLoading) => !isLoading),
    []
  );
  const toggleModalActive = useCallback(
    () => setModalActive((modalActive) => !modalActive),
    []
  );

  const toastMarkup = toastActive ? (
    <Toast onDismiss={toggleToastActive} content="Changes saved" />
  ) : null;

  const userMenuActions = [
    // {
    //   items: [
    //     {
    //       content: "Your profile",
    //       icon: ProfileMinor,
    //       onAction: () => navigate("/profile"),
    //     },
    //   ],
    // },
    {
      items: [
        {
          content: "Log out",
          icon: ExitIcon,

          onAction: () => {
            axios
              .post(`/logout`)
              .then((result) => {
                navigate("/");
              })
              .catch((err) => {
                Cookies.set("momtazaccesstoken", null);
                navigate("/");
              });
          },
        },
      ],
    },
  ];
  const customIcon = {
    viewBox: "0 0 20 20",
    body: '<g transform="scale(0.5)"><path d="M16 0 C6 0 2 4 2 14 L2 22 L6 24 L6 30 L26 30 L26 24 L30 22 L30 14 C30 4 26 0 16 0 M9 12 A4.5 4.5 0 0 1 9 21 A4.5 4.5 0 0 1 9 12 M23 12 A4.5 4.5 0 0 1 23 21 A4.5 4.5 0 0 1 23 12"></path></g>',
  };
  const contextualSaveBarMarkup = isDirty ? (
    <ContextualSaveBar
      message="Unsaved changes"
      saveAction={{
        onAction: handleSave,
      }}
      discardAction={{
        onAction: handleDiscard,
      }}
    />
  ) : null;

  const userMenuMarkup = (
    <TopBar.UserMenu
      actions={userMenuActions}
      name={Cookies.get("momtazname") && Cookies.get("momtazname")}
      initials={
        Cookies.get("momtazname")
          ? (() => {
              const parts = Cookies.get("momtazname").trim().split(" ");
              if (parts.length === 1) {
                return parts[0].charAt(0).toUpperCase();
              } else {
                return (
                  parts[0].charAt(0).toUpperCase() +
                  " " +
                  parts[1].charAt(0).toUpperCase()
                );
              }
            })()
          : ""
      }
      open={userMenuActive}
      onToggle={toggleUserMenuActive}
    />
  );

  const searchResultsMarkup = (
    <ActionList
      items={[
        { content: "Shopify help center" },
        { content: "Community forums" },
      ]}
    />
  );

  const searchFieldMarkup = (
    <TopBar.SearchField
      onChange={handleSearchFieldChange}
      value={searchValue}
      placeholder="Search"
    />
  );

  const topBarMarkup = (
    <TopBar
      showNavigationToggle
      userMenu={userMenuMarkup}
      // searchResultsVisible={searchActive}
      // searchField={searchFieldMarkup}
      // searchResults={searchResultsMarkup}
      // onSearchResultsDismiss={handleSearchResultsDismiss}
      onNavigationToggle={toggleMobileNavigationActive}
      logoSuffix
    />
  );

  const navigationMarkup = (
    <Navigation location="/">
      <Navigation.Section
        items={[
          // {
          //   url: "/",
          //   onClick: () => navigate("/admin/dashboard"),
          //   label: "Dashboard",
          //   icon: ChartVerticalFilledIcon,
          //   selected: window.location.href.indexOf("/admin/dashboard") > -1,
          // },
          {
            url: "/",
            onClick: () => navigate("/admin/banners"),
            label: "Banners",
            icon: ImageIcon,
            selected: window.location.href.indexOf("/admin/banners") > -1,
          },
          {
            url: "/",
            onClick: () => navigate("/admin/universities"),
            label: "Universities",
            icon: InventoryFilledIcon,
            selected: window.location.href.indexOf("/admin/universities") > -1,
          },
          {
            url: "/",
            onClick: () => navigate("/admin/schools"),
            label: "Schools",
            icon: InventoryFilledIcon,
            selected: window.location.href.indexOf("/admin/schools") > -1,
          },
          {
            url: "/",
            onClick: () => navigate("/admin/classes"),
            label: "Classes",
            icon: CategoriesIcon,
            selected: window.location.href.indexOf("/admin/classes") > -1,
          },
          {
            url: "/",
            onClick: () => navigate("/admin/subjects"),
            label: "Subjects",
            icon: CategoriesIcon,
            selected: window.location.href.indexOf("/admin/subjects") > -1,
          },
          {
            url: "/",
            onClick: () => navigate("/admin/professors"),
            label: "Professors",
            icon: PersonFilledIcon,
            selected: window.location.href.indexOf("/admin/professors") > -1,
          },
          {
            url: "/",
            onClick: () => navigate("/admin/courses"),
            label: "Courses",
            icon: BookIcon,
            selected: window.location.href.indexOf("/admin/courses") > -1,
          },
          // {
          //   url: "/",
          //   onClick: () => navigate("/admin/notes"),
          //   label: "Notes",
          //   icon: CategoriesIcon,
          //   selected: window.location.href.indexOf("/admin/notes") > -1,
          // },
          // {
          //   url: "/",
          //   onClick: () => navigate("/admin/sessions"),
          //   label: "Private Tutoring",
          //   icon: BookIcon,
          //   selected: window.location.href.indexOf("/admin/sessions") > -1,
          // },
          {
            url: "/",
            onClick: () => navigate("/admin/requests"),
            label: "Requests",
            icon: ClipboardCheckFilledIcon,
            selected: window.location.href.indexOf("/admin/requests") > -1,
            badge: String(pendingRequestsNumber),
          },
          {
            url: "/",
            onClick: () => navigate("/admin/users"),
            label: "Users",
            icon: PersonFilledIcon,
            selected: window.location.href.indexOf("/admin/users") > -1,
          },
          {
            url: "/",
            onClick: () => navigate("/admin/orders"),
            label: "Orders",
            icon: PersonFilledIcon,
            selected: window.location.href.indexOf("/admin/orders") > -1,
          },
          {
            url: "/",
            onClick: () => navigate("/admin/notifications"),
            label: "Notifications",
            icon: NotificationFilledIcon,
            selected: window.location.href.indexOf("/admin/notifications") > -1,
          },
          {
            url: "/",
            onClick: () => navigate("/admin/analytics"),
            label: "Analytics",
            icon: ChartVerticalFilledIcon,
            selected: window.location.href.indexOf("/admin/analytics") > -1,
            subNavigationItems: [
              {
                onClick: () => navigate("/admin/analytics"),
                selected: window.location.pathname === "/admin/analytics",
                label: "Overview",
                icon: ChartLineIcon,
              },
              {
                onClick: () => navigate("/admin/analytics/revenue"),
                selected: window.location.href.indexOf("/admin/analytics/revenue") > -1,
                label: "Revenue",
                icon: ChartVerticalFilledIcon,
              },
              {
                onClick: () => navigate("/admin/analytics/customers"),
                selected: window.location.href.indexOf("/admin/analytics/customers") > -1,
                label: "Customers",
                icon: PersonFilledIcon,
              },
              {
                onClick: () => navigate("/admin/analytics/products"),
                selected: window.location.href.indexOf("/admin/analytics/products") > -1,
                label: "Products",
                icon: InventoryFilledIcon,
              },
              {
                onClick: () => navigate("/admin/analytics/sales"),
                selected: window.location.href.indexOf("/admin/analytics/sales") > -1,
                label: "Sales",
                icon: OrderFilledIcon,
              },
            ],
          },
          {
            url: "/",
            onClick: () => navigate("/admin/hls-converter"),
            label: "HLS Converter",
            icon: ChartFunnelIcon,
            selected: window.location.href.indexOf("/admin/hls-converter") > -1,
          },
        ]}
      ></Navigation.Section>
      <Navigation.Section
        separator
        items={[
          {
            label: "Settings",
            url: "/",
            onClick: () => navigate("/admin/settings/users-and-permissions"),
            icon: SettingsFilledIcon,
            selected: window.location.href.indexOf("/admin/settings") > -1,
            subNavigationItems: [
              {
                onClick: () =>
                  navigate("/admin/settings/users-and-permissions"),
                selected:
                  window.location.href.indexOf(
                    "/admin/settings/users-and-permissions"
                  ) > -1 && true,
                label: "Users and Permissions",
                icon: PersonFilledIcon,
              },
              {
                onClick: () => navigate("/admin/settings/emails"),
                selected:
                  window.location.href.indexOf("/admin/emails") > -1 && true,
                label: "Emails",
                icon: EmailIcon,
              },
            ],
          },
        ]}
      />
    </Navigation>
  );
  const loadingMarkup = isLoading ? <Loading /> : null;

  const skipToContentTarget = (
    <a id="SkipToContentTarget" ref={skipToContentRef} tabIndex={-1} />
  );

  const actualPageMarkup = (
    <Page title="Account">
      <Layout>
        {skipToContentTarget}
        <Layout.AnnotatedSection
          title="Account details"
          description="Jaded Pixel will use this as your account information."
        >
          <Card sectioned>
            <FormLayout>
              <TextField
                label="Full name"
                value={nameFieldValue}
                onChange={handleNameFieldChange}
              />
              <TextField
                type="email"
                label="Email"
                value={emailFieldValue}
                onChange={handleEmailFieldChange}
              />
            </FormLayout>
          </Card>
        </Layout.AnnotatedSection>
      </Layout>
    </Page>
  );

  const loadingPageMarkup = (
    <SkeletonPage>
      <Layout>
        <Layout.Section>
          <Card sectioned>
            <Text>
              <SkeletonDisplayText size="small" />
              <SkeletonBodyText lines={9} />
            </Text>
          </Card>
        </Layout.Section>
      </Layout>
    </SkeletonPage>
  );

  const pageMarkup = isLoading ? loadingPageMarkup : actualPageMarkup;

  const modalMarkup = (
    <Modal
      open={modalActive}
      onClose={toggleModalActive}
      title="Contact support"
      primaryAction={{
        content: "Send",
        onAction: toggleModalActive,
      }}
    >
      <Modal.Section>
        <FormLayout>
          <TextField
            label="Subject"
            value={supportSubject}
            onChange={handleSubjectChange}
          />
          <TextField
            label="Message"
            value={supportMessage}
            onChange={handleMessageChange}
            multiline
          />
        </FormLayout>
      </Modal.Section>
    </Modal>
  );

  const theme = {
    colors: {
      surface: "#FFFFFF",
      onsurface: "#212B36",
    },
  };
  const logo = {
    width: 150,

    topBarSource: logoImg,
    // url: "/admin/employees",
    // accessibilityLabel: "Jaded Pixel",
  };

 return (
  <div style={{ minHeight: "100vh" }}>
      <AppProvider
        // theme={theme}
        i18n={{
          Polaris: {
            Avatar: {
              label: "Avatar",
              labelWithInitials: "Avatar with initials {initials}",
            },
            ContextualSaveBar: {
              save: "Save",
              discard: "Discard",
            },
            TextField: {
              characterCount: "{count} characters",
            },
            TopBar: {
              toggleMenuLabel: "Toggle menu",

              SearchField: {
                clearButtonLabel: "Clear",
                search: "Search",
              },
            },
            Modal: {
              iFrameTitle: "body markup",
            },
            Frame: {
              skipToContent: "Skip to content",
              Navigation: {
                closeMobileNavigationLabel: "Close navigation",
              },
            },
          },
        }}
      >
        <Frame
          topBar={topBarMarkup}
          navigation={navigationMarkup}
          showMobileNavigation={mobileNavigationActive}
          onNavigationDismiss={toggleMobileNavigationActive}
          skipToContentTarget={skipToContentRef.current}
          logo={logo}
        >
          {props.children}
        </Frame>
      </AppProvider>
    </div>
  );
}
export default React.memo(NavigationLayout);
